import { GAME_NAME } from "../../common/constants.ts";

export const GAME_LINKS = [
	{
		name: "Basketball GM",
		url: "https://sportsgm-private.pages.dev/",
	},
	{
		name: "Football GM",
		url: "https://football.sportsgm-private.pages.dev/",
	},
	{
		name: "ZenGM Baseball",
		url: "https://baseball.sportsgm-private.pages.dev/",
	},
	{
		name: "ZenGM Hockey",
		url: "https://hockey.sportsgm-private.pages.dev/",
	},
] as const;

export const GameLinks = ({
	noLinks,
	thisGameText,
}: {
	noLinks?: boolean;
	thisGameText?: string;
}) => {
	const otherGames = GAME_LINKS.filter((game) => game.name !== GAME_NAME);
	const thisGame = GAME_LINKS.find((game) => game.name === GAME_NAME);
	if (!thisGame) {
		throw new Error("Game not found");
	}

	return (
		<>
			{thisGameText ? thisGameText : thisGame.name},{" "}
			{noLinks ? (
				`${otherGames[0]!.name}, ${otherGames[1]!.name}, and ${otherGames[2]!.name}`
			) : (
				<>
					<a href={otherGames[0]!.url}>{otherGames[0]!.name}</a>,{" "}
					<a href={otherGames[1]!.url}>{otherGames[1]!.name}</a>, and{" "}
					<a href={otherGames[2]!.url}>{otherGames[2]!.name}</a>
				</>
			)}
		</>
	);
};
